import React from "react";
import BaseComponent from 'Core/components/BaseComponent';
import PropTypes from 'prop-types';
import Label from 'Core/components/display/Label';

class NoReportItem extends BaseComponent {
	constructor(props) {
		super(props, {
			optimizedUpdate: true,
		});
	}
	
	render() {
		const {className, label} = this.props;
		
		return (
			<div className={`reports-dropdown-item ${className}`} data-label={true}>
				<Label content={label} />
			</div>
		);
	}
}

/**
 * Define the component's own props that can be passed to it by parent components
 */
NoReportItem.propTypes = {
	className: PropTypes.string,
	label: PropTypes.string,
};

/**
 * Define component default values for own props
 */
NoReportItem.defaultProps = {
	className: '',
	label: '—',
};

export default NoReportItem;